import React from 'react';

import Icon, { Icons } from '@shared/Icons/Icon';
import ExternalLink from '../ExternalLink';
import UserMenuLocaleFlag from '../UserMenu/components/UserMenuLocaleFlag';
import { supportedLocales } from '../../data/locale';
import { setPreferredLocale } from '../../utils/locale';

import {
  largeIcon,
  social,
  select,
  regionSelector,
  regionSelectorLabel,
} from './styles.module.css';

const getFacebookUrl = (userSelectedLocale) =>
  ({
    gb: 'https://www.facebook.com/letsdothisuk',
    us: 'https://www.facebook.com/letsdothisusa/',
    au: 'https://www.facebook.com/letsdothisau/',
  }[(userSelectedLocale && userSelectedLocale.toLowerCase()) || 'gb']);

const localeOnChange = ({ target }) => {
  const { value: countryCode } = target;

  setPreferredLocale(countryCode);
  if (__CLIENT__) {
    window.location = `/${
      supportedLocales.find((locale) => locale.iso2 === countryCode).slug
    }`;
  }
};

const renderLocaleOptions = () => {
  return supportedLocales.map((locale) => {
    return (
      <option
        value={locale.iso2}
        key={locale.iso2}
      >{`${locale.emoji} ${locale.labelLong}`}</option>
    );
  });
};

const Row2ExtraInfo = ({ userSelectedLocale }) => (
  <>
    <div className={regionSelector}>
      <UserMenuLocaleFlag userSelectedLocale={userSelectedLocale} />
      <label htmlFor="localeSelect">
        <span className={regionSelectorLabel}>Change region</span>
        <select
          id="localeSelect"
          onChange={localeOnChange}
          className={select}
          defaultValue={userSelectedLocale || 'Change region'}
        >
          <option disabled hidden>
            Change region
          </option>
          {renderLocaleOptions()}
        </select>
      </label>
    </div>
    <div className={social}>
      <ExternalLink follow href={getFacebookUrl(userSelectedLocale)}>
        <Icon className={largeIcon} icon={Icons.FACEBOOK} />
      </ExternalLink>
      <ExternalLink
        follow
        href="https://www.strava.com/clubs/252814/discussion"
      >
        <Icon className={largeIcon} icon={Icons.STRAVA.WHITE} />
      </ExternalLink>
      <ExternalLink follow href="https://www.instagram.com/letsdothis.com_">
        <Icon className={largeIcon} icon={Icons.INSTAGRAM.WHITE} />
      </ExternalLink>
      <ExternalLink follow href="https://twitter.com/letsdothisrace">
        <Icon className={largeIcon} icon={Icons.TWITTER} />
      </ExternalLink>
    </div>
  </>
);

export default Row2ExtraInfo;
